const defaultThreshold = {
  percent: undefined,
  name: 'default',
  colour: 'var(--blue-60)',
};

// thresholds for bin levels
// specify colour to use for bin levels up to the threshold.percent
const thresholds = [
  {
    percent: 30,
    name: 'low',
    colour: 'var(--red-20)',
    darkColour: 'var(--red-20)',
    darkerColour: 'var(--red-30)',
  },
  {
    percent: 50,
    name: 'medium',
    colour: 'var(--orange-20)',
    darkColour: 'var(--orange-20)',
    darkerColour: 'var(--orange-30)',
  },
  {
    percent: 100,
    name: 'high',
    colour: 'var(--green-15)',
    darkColour: 'var(--green-15)',
    darkerColour: 'var(--green-20)',
  },
];

export const LevelColours = {
  getThreshold(percent) {
    if (!thresholds) {
      return defaultThreshold;
    }
    for (const threshold of thresholds) {
      if (percent <= threshold.percent) {
        return threshold;
      }
    }
    return thresholds[thresholds.length - 1];
  },

  getThresholdByName(name) {
    return thresholds.find(threshold => threshold.name === name);
  },
};

export const LevelColoursMixin = (superClass) => class extends superClass {
  constructor() {
    super();
    this.thresholds = [...thresholds];
  }

  getThreshold(percent) {
    return LevelColours.getThreshold(percent);
  }

  getLevelColour(percent, variant = 'colour') {
    return LevelColours.getThreshold(percent)[variant];
  }
};
